import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { UserService } from "src/app/services/user.service";
import { SupportService } from "src/app/services/support.service";
import { ImportsModule } from "./imports";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { Segnalazione } from "src/app/models/segnalazione.model";
import { Segnalazione_Firestore } from "src/app/models/firestore/segnalazioneFirestore.model";
import { FileAllegato } from "src/app/models/storage/fileAllegato.model";
import { Intervento_Firestore } from "src/app/models/firestore/interventoFirestore.model";

interface Release {
  name: string;
  code: string;
}

@Component({
  selector: "galleria_allegati_intervento",
  templateUrl: "./galleria_allegati_interventi.component.html",
  styleUrls: ["./galleria_allegati_interventi.component.css"],
  imports: [ImportsModule],
  standalone: true,
})
export class GalleriaAllegatiInterventoComponent implements OnInit {

  allegati: any[] | undefined;

  responsiveOptions: any[] | undefined;

  intervento:Intervento_Firestore;

  constructor(
    public dialogService: DialogService,
    private logger: NGXLogger,
    private googleStorageService:GoogleStorageService,
    public config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
  ) {
    this.intervento = this.config.data.intervento;
  }

  ngOnInit(): void {
    // this.logger.info("NG INIT @ GALLERIA ALLEGATI INTERVENTO --> "+ this.intervento.codice);
    this.googleStorageService.getAllegatiRapportinoPerGalleria(this.intervento.codice).then(allegati =>{
      this.allegati = allegati;
    });
  }

  scaricaFile(allegato:FileAllegato){
    this.googleStorageService.downloadAllegatoInterventoFromGoogleStorage(this.intervento.codice, allegato.name);
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.googleStorageService.downloadAllegatiInterventoromGoogleStorage(this.intervento.codice).then(ok =>{
        this.dialogRef.close({ success: true });
      }
      ).catch(error =>{
        this.dialogRef.close({ success: false });
      });

    }
  }



}
